import {Node} from 'tiptap';

export default class CustomParagraph extends Node {
    get name() {
        return 'paragraph';
    }

    get schema() {
        return {
            attrs: {
                alignment: {default: undefined}, // Default alignment is not set
            },
            content: 'inline*',
            group: 'block',
            parseDOM: [{
                tag: 'p',
                getAttrs: dom => ({
                    alignment: dom.style.textAlign, // Get the alignment from the DOM
                }),
            }],
            toDOM: node => {
                const {alignment} = node.attrs;
                let style = alignment ? `text-align: ${alignment}` : undefined
                return ['p', {style}, 0]; // Apply the alignment
            },
        };
    }

    commands({type}) {
        return {
            align: alignment => (state, dispatch) => {
                const {$from, $to} = state.selection;
                const tr = state.tr;

                // Apply the alignment to all paragraphs in the selection
                state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
                    if (node.type === type) {
                        tr.setNodeMarkup(pos, type, {...node.attrs, alignment});
                    }
                });

                dispatch(tr);
            },
        };
    }
}
